DM.Module.Recaptcha = ((DM) => {

    const Attrs = {
        COOKIE_NAME: DM.Config.Recaptcha.cookieName,
        PUBLIC_KEY: '6Lf2Aj0aAAAAAEdjzn3rTNJ_SrX9uktgfj9MbhaA', 
        API_URL: 'https://www.google.com/recaptcha/api.js?render=',
        ENDPOINT: '/Account/PostCaptcha?captchaResponse='
    };

    class Recaptcha {
        //TODO: move to trackers
        sendResponseToServer(captchaResponse) {
            return fetch(Attrs.ENDPOINT + captchaResponse, {
                method: 'POST'
            });
        }
        initRecaptcha(action) {
            if (!DM.Utils.getCookie(DM.Cookies.KillTrackers) && !DM.Utils.killTracker('recaptcha')) {
                if (!DM.Utils.getCookie(Attrs.COOKIE_NAME)) {
                    const script = document.createElement('script');
                    script.src = Attrs.API_URL + Attrs.PUBLIC_KEY;
                    script.defer = true;
                    script.onload = () => {
                        window.grecaptcha.ready(() => {
                            window.grecaptcha.execute(Attrs.PUBLIC_KEY, { action: action }).then(
                                (token) => {
                                    this.sendResponseToServer(token);
                                },
                                (err) => {
                                    console.error(err);
                                });
                        });
                    }

                    script.onerror = (_ev, _s, _l, _c, err) => {
                        console.error(err);
                    };

                    document.body.appendChild(script);
                }
            }
        }
    }
    const recaptcha = new Recaptcha();
    if (DM.Config.Recaptcha.enabled) {
        window.addEventListener('productListPageRefresh', (event) => {
            DM.Module.Recaptcha.initRecaptcha('productListPageRefresh');
        });
        window.addEventListener('firstInteraction', () => {
            recaptcha.initRecaptcha('init');
        });
    }

    return recaptcha;

})(window.DM);

